import * as types from '../mutation-types'
import fairs from '@/api/fair'
import Vue from 'vue'

const state = {
  fairs: {},
  eligibleFairs: {}
}

const getters = {
  fairs: (state) => {
    return state.fairs
  },
  eligibleFairs: (state) => {
    return state.eligibleFairs
  }
}

const actions = {
  getFairsForProject ({ commit, state }, projectID) {
    return new Promise((resolve, reject) => {
      fairs.getFairsForProject(projectID).then((response) => {
        const fairs = response.data.result.fairs
        fairs.forEach((fair) => {
          commit(types.ADD_FAIR, fair)
        })
        commit(types.ELIGIBLE_FAIRS, fairs)
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  createFairProject ({ commit, state }, { projectID, data }) {
    return new Promise((resolve, reject) => {
      fairs.createFairProject(projectID, data).then((response) => {
        console.log(data.fairs)
        commit(types.REMOVE_FROM_ELIGIBLE_FAIRS, data.fairs)
        const success = response.data.result.success
        resolve(success)
      }, (error) => {
        reject(error)
      })
    })
  },
  clearEligibleFairs ({ commit, state }) {
    commit(types.CLEAR_FAIRS)
  }
}

const mutations = {
  [types.ADD_FAIR] (state, fair) {
    Vue.set(state.fairs, fair.abbreviation, fair)
  },
  [types.ELIGIBLE_FAIRS] (state, fairs) {
    state.eligibleFairs = fairs
  },
  [types.REMOVE_FROM_ELIGIBLE_FAIRS] (state, fairs) {
    // 'fairs' is an array of a single or multiple fairIDs
    // use filter to remove said fair(s)
    state.eligibleFairs = state.eligibleFairs.filter((eligibleFair) => {
      return !fairs.includes(eligibleFair.id)
    })
  },
  [types.CLEAR_FAIRS] (state) {
    state.eligibleFairs = {}
    state.fairs = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
